import React, {Component, useContext, useEffect, useState} from "react";
import {NavLink} from "react-router-dom";

import BreadCrumbContext from "../../contexts/breadCrump";
import {
	Collapse,Menu
} from 'antd';
import APIDocumentationMenu from "./Documentation/Menu";
import APIDocumentationUsersList from "./Documentation/Users/List";
import APIDocumentationUsersCreate from "./Documentation/Users/Create";
import APIDocumentationUsersRead from "./Documentation/Users/Read";
import APIDocumentationUsersUpdate from "./Documentation/Users/Update";
import APIDocumentationUsersDelete from "./Documentation/Users/Delete";
import APIDocumentationAction from "./Documentation/Action"

import '../../css/documentation.css';
import API2 from "../../components/api2";




export default function APIDocumentation(props) {
    const AP = API2();
    const [menu, setMenu] = useState([]);
    const rootSubmenuKeys = [];
    const [openKeys, setOpenKeys] = React.useState([]);
    const [selectedKeys, setSelectedKeys] = React.useState([]);

    //const [menuController, setMenuController] = useState([]);
    const [menuKey, setMenuKey] = useState([]);

	const setBreadCrumbs = useContext(BreadCrumbContext);
	useEffect(() => {
		setBreadCrumbs([
			<span><i className="fas fa-book"/> API</span>,
		    <span><i className="fas fa-info-circle"/> Documentation</span>
        ]);

        AP.get('/documentation/menu')
            .then(function(res){
                setMenu(res);
            });


        let group;
        let controller;
        let action;
        let openKey;
        let selectedKey;
        if(props.match.params.action){
            group       = props.match.params.group;
            controller  = props.match.params.controller;
            action      = props.match.params.action;
            openKey     = group;
            selectedKey = group+"_"+controller+"_"+action;
        }else{
            controller  = props.match.params.group;
            action      = props.match.params.controller;
            openKey     = controller;
            selectedKey = controller+"_"+action;
        }

        if(menuKey!=selectedKey) {
            setMenuKey(selectedKey);
        }

        setOpenKeys([openKey]);
	}, []);

    const ct = {
        GET: <span style={{color:"green",float:"right",fontSize:"10px"}}>GET</span>,
        POST: <span style={{color:"blue",float:"right",fontSize:"10px"}}>POST</span>,
        PATCH: <span style={{color:"purple",float:"right",fontSize:"10px"}}>PATCH</span>,
        DELETE: <span style={{color:"red",float:"right",fontSize:"10px"}}>DELETE</span>
    };

    function menuChange(e){
        setMenuKey(e.key);
        console.log(e);
    }



	function buildMenu(){

        return (
            <Menu
                style={{ width: 256 }}
                mode="inline"
                openKeys={openKeys}
                selectedKeys={[menuKey]}
                onClick={menuChange}
                onOpenChange={onOpenChange}
            >
                {menu.map(item => {
                    {rootSubmenuKeys.push(item.key)}
                    return <Menu.SubMenu key={item.key} title={item.name}>
                            {item.actions && item.actions.map(action =>
                                <Menu.Item key={item.key + "_" + action.key}><NavLink
                                    to={"/api/documentation/" + item.key + "/" + action.key}
                                    activeClassName="current">{action.name}{ct[action.method]}</NavLink></Menu.Item>
                            )}
                            {item.controllers && item.controllers.map(controller =>
                                <Menu.ItemGroup key={item.key + "_" + controller.key} title={controller.name}>
                                    {controller.actions && controller.actions.map(action =>
                                        <Menu.Item key={item.key + "_" + controller.key + "_" + action.key}><NavLink
                                            to={"/api/documentation/" + item.key + "/" + controller.key + "/" + action.key}
                                            activeClassName="current">{action.name}{ct[action.method]}</NavLink></Menu.Item>
                                    )}
                                </Menu.ItemGroup>
                            )}
                        </Menu.SubMenu>
                    }
                )}
            </Menu>
        );
	}
    const onOpenChange = keys => {
        const latestOpenKey = keys.find(key => openKeys.indexOf(key) === -1);
        if (rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
            setOpenKeys(keys);
        } else {
            setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
        }
    };

    return (
        <div style={{display:"flex"}}>
			<div>
				{buildMenu()}
			</div>
			<div className="content_inner">
				{props.match.params.controller
				&& <APIDocumentationAction menu={menu} {...props} menuKey={menuKey}/>
				||
				<>
					<div className="HubBlock HubBlock--text flex is-viewing is-padded">
						<div className="HubBlock-inner flex-1 w-full">
							<div className="HubBlock-content">
								<div className="MarkdownViewer markdown-body">
									<div className="HtmlViewer">
										<h1>
											<a className="anchor cursor-pointer" aria-current="false"
											   id="metabolic-health-api" href="#metabolic-health-api">
											</a>Metabolic Health API
										</h1>
										<ul>
											<li><strong>Version:</strong> 2.0.0</li>
											<li><strong>Host:</strong> {process.env.REACT_APP_API_ENDPOINT}</li>
											<li><strong>Protocols:</strong> <code>https</code></li>
											<li><strong>Accepts:</strong>
												<code>application/json</code>, <code>multipart/form-data</code></li>
											<li><strong>Responds With:</strong>
												<code>application/json</code>, <code>application/xml</code></li>
										</ul>
									</div>
								</div>
							</div>
						</div>
					</div>

					<Collapse accordion style={{marginTop: "40px"}}>
						<Collapse.Panel header="More Info" key="1">
							<ul>
								<li>
									<strong><a href="mailto:dev@metabolichealth.com.au" target="_blank">Contact Us by Email</a> </strong>
								</li>
								<li>
									<strong>Terms Of Service</strong>: <a href="" target="_blank">https://zoom.us/docs/en-us/zoom_api_license_and_tou.html</a>
								</li>
								<li>
									<strong>License:</strong> <a href="https://opensource.org/licenses/MIT" target="_blank">MIT for OAS 2.0</a>
								</li>
							</ul>
						</Collapse.Panel>
					</Collapse>

					<div className="HubBlock HubBlock--text flex is-viewing is-last is-padded"
						 style={{marginTop: "40px"}}>
						<div className="HubBlock-inner flex-1 w-full">
							<div className="HubBlock-content">
								<div className="MarkdownViewer markdown-body">
									<div className="HtmlViewer"><p>The Metabolic Health API allows developers to access
										information from
										Metabolic Health. You can use this API to build private services or public
										applications.
										To access your credentials and create private/public applications, please visit
										the <NavLink to="/api/key" activeClassName="current">API Key page</NavLink>.
										All endpoints are available via <code>https</code> and are located
										at <code>{process.env.REACT_APP_API_ENDPOINT}</code>.</p>
										<p>For instance you can list all users on an account
											via <code>{process.env.REACT_APP_API_ENDPOINT}/users</code>.</p>
									</div>
								</div>
							</div>
						</div>
					</div>
				</>
				}
			</div>
        </div>
    );
}

